export default "__VITE_ASSET__3gULLdvT__"